import NavBar from "./componets/NavBar";
import Hero from "./componets/hero";
import DetailsBar from "./componets/DetailsBar";


function App() {
  return (
    <div>
      <NavBar />
      <Hero />
      <DetailsBar />
    </div>
  );
}

export default App;
